const siteName = "Koova"

const onProduction = true

const baseUrl = onProduction ? 'https://koova.co.ke' : 'http://127.0.0.1:8000'

const pageSize = 9

const multipartHeader = { "Content-Type": "multipart/form-data" }

const toastError = "Something Went Wrong"

const api = '/api/v1'

const toCommas = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const makeProfileLetter = (user) => {
    const fullName = user?.full_name
    if (fullName) {
        return fullName.charAt(0)
    }
    const mail = user?.email
    if (!mail) {
        return '0'
    }
    const letter = mail.charAt(0)
    return letter.toUpperCase()
}

const toasterPosition = "bottom-center"

const toasterOptions = {
    className: "rounded-md border"
}

const errorMsg = "Something Went Wrong"

const getPageValue = (url) =>{
    const urlString = url.split("?")[1]
    const param = new URLSearchParams(urlString)
    return param.get("page")
}

const getCurrentPage = (previous, next) => {
    if (next !== null) {
        const nextPage = getPageValue(next)
        return parseInt(nextPage) - 1
    } else {
        if (previous !== null) {
            const previousPage = getPageValue(previous)
            if(isNaN(parseInt(previousPage))){
                return 2
            }
            return parseInt(previousPage) + 1
        }
        if (next === null && previous === null) {
            return 1
        }
    }
}

const changeUrlPageParam = (
    value, value_type, hasFiltered,
    setHasFiltered, filterCtx, setSearchParams) => {
    if (!hasFiltered) {
        setHasFiltered(true)
    }
    if (value_type === "model") {
        filterCtx.setModelFilter(value)
    } else if (value_type === "brand") {
        filterCtx.setBrandFilter(value)
    }
    if (value) {
        setSearchParams((params) => {
            params.set(value_type, value)
            return params
        })
    } else {
        setSearchParams((params) => {
            params.delete(value_type)
            return params
        })
    }
}

function formatMinutes(minutes) {
    if (minutes >= 60) {
        var hours = Math.floor(minutes / 60);
        var remainingMinutes = minutes % 60;
    
        var hoursString = hours < 10 ? '0' + hours : hours;
        var minutesString = remainingMinutes < 10 ? '0' + remainingMinutes : remainingMinutes;
    
        return hoursString + 'hr ' + minutesString + ' mins';
    } else {
        return Math.floor(minutes) + ' mins';
    }
}

const isUrl = (text) => {
    const str = String(text)
    return str.toLowerCase().includes('http')
}

const getImageUrl = (url) => {
    if (isUrl(url)) {
        return url
    }
    return baseUrl + url
}

function getUserRoleLabel(user) {
    if (!user) return null;

    if (user.is_admin) {
        return 'Admin';
    }

    if (user.is_superuser && !user.is_admin) {
        return 'Superuser';
    }

    if (user.is_vendor) {
        return 'Vendor';
    }

    if (!user.is_admin && !user.is_superuser && !user.is_vendor) {
        return 'User';
    }

    return 'User';
}

const utils = {
    siteName,
    multipartHeader,
    baseUrl,
    toCommas,
    makeProfileLetter,
    toasterPosition,
    toasterOptions,
    errorMsg,
    getCurrentPage,
    getPageValue,
    changeUrlPageParam,
    toastError,
    formatMinutes,
    getImageUrl,
    api,
    pageSize,
    getUserRoleLabel
}


export default utils